export var prepMatcher = function (primaryRoutes, fallbackRoute) { return function (slug) {
    var matchedRoute = primaryRoutes.find(function (route) { return route.matchOnSlug(slug); });
    if (typeof matchedRoute === "undefined")
        return fallbackRoute;
    return matchedRoute;
}; };
